define(function(require) {

	const rowView = require('./v_itv_lp_item');
	const tpl = require('./t_cpv_lp_list.hbs');

	return Marionette.CompositeView.extend({
		config:{},
		tagName: 'ul',
		childView: rowView,
		template:tpl,
		// className: 'picker-list',
		ui:{
		},
		collectionEvents: {
		},
		initialize:function(options){
			this.collection = options.collection;
			this.selectedSitesCollection =  options.selectedSitesCollection;
			this.siteIndex = 1;
		},

		childViewOptions:function(model, index){
			return {
				config:this.config,
				collection: this.collection,
				selectedSitesCollection: this.selectedSitesCollection,
				siteType: model.get('_siteType'),
				headerRegion: this.options.headerRegion
			}
		},
		filter: function (child, index, collection) {
			//filter out any sites that don't match our primary setting - don't show the primary site in additional sites section and vice a versa
			
			if(child.get('_siteType') === 'asset'){
				return (child.get('typeDisplayText') === this.options.assetType);
			}
			return (child.get('_siteType') === this.options.siteType);
		},
		templateHelpers: function () {
			//get the number of sites being displayed in this view
			return {
				headerRegion: ()=>{
					return this.collection.findWhere({_siteType:this.options.siteType.toLowerCase()}) != undefined ?this.options.headerRegion : "";					
				
				}
				
			}	
		}
	});
});
